// removed by extract-text-webpack-plugin
module.exports = {"Loading":"loading__Loading__1T-QW","SmallLoading":"loading__SmallLoading__1f9v6","Graph":"loading__Graph__3QT1-"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Loading/loading.css
// module id = 929
// module chunks = 2